// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__4ENlq","fadeInOut":"loader_fadeInOut__rzZLY","shadow324":"loader_shadow324__cR5KD","jump7456":"loader_jump7456__48fKB"};